import map from 'lodash/map';
import groupBy from 'lodash/groupBy';
import mapValues from 'lodash/mapValues';
import values from 'lodash/values';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getFilteredDataset, getCategoricalSummary, getLevelsRowFrequencyDatasetByName } from 'store/dataset';

import DoubleCategoricalComponent from './Component';
import { getRelativeFrequencySammaryByFrequencySummary, getObjectByArray, getLevelLikeObject } from 'calculators/graphicalStatistics/frequencyTable';
import { removeEmptyValuesFromDataset } from 'utilities';

class DoubleCategoricalContainer extends React.Component {
  get stackedBarChartData () {
    const {
      getLevelsFrequency,
      filteredDataset,
      firstParameter,
      secondParameter,
      isFrequencyTable,
      isTypeOfGraphsFrequency
    } = this.props;
    if (isFrequencyTable) {
      const { levels: frequencySummary } = getLevelsFrequency(firstParameter);
      if (isTypeOfGraphsFrequency) {
        return getObjectByArray(frequencySummary);
      }

      const relativeFrequency = getRelativeFrequencySammaryByFrequencySummary(frequencySummary);
      return getObjectByArray(relativeFrequency);
    }

    const filteredDatasetWithoutEmptyFields = removeEmptyValuesFromDataset(filteredDataset, firstParameter, secondParameter);
    const datasetGroupedByFirstParameter = groupBy(filteredDatasetWithoutEmptyFields, firstParameter);

    const summary = map(datasetGroupedByFirstParameter, (bar, firstParameterValue) => {
      const barGroupedBySecondParameter = groupBy(bar, secondParameter);

      const levels = mapValues(barGroupedBySecondParameter,
        (level, secondParameterValue) => ({
          name: secondParameterValue,
          count: level.length
        })
      );

      return { name: firstParameterValue, count: bar.length, levels };
    }
    );
    if (isTypeOfGraphsFrequency) {
      return summary;
    }

    return getRelativeFrequencySammaryByFrequencySummary(summary);
  }

  get levels () {
    const {
      secondParameter,
      categoricalSummary,
      isFrequencyTable,
      isTypeOfGraphsFrequency
    } = this.props;
    const frequencySummary = categoricalSummary[secondParameter].levels;

    if (isTypeOfGraphsFrequency) {
      if (isFrequencyTable) {
        return getLevelLikeObject(frequencySummary);
      }
      return frequencySummary;
    }
    return getLevelLikeObject(getRelativeFrequencySammaryByFrequencySummary(values(frequencySummary)));
  }

  render () {
    return (
      <DoubleCategoricalComponent
        levels={this.levels}
        bars={this.stackedBarChartData}
        firstParameter={this.props.firstParameter}
        secondParameter={this.props.secondParameter}
      />
    );
  }
}

DoubleCategoricalContainer.propTypes = {
  filteredDataset: PropTypes.array.isRequired,
  categoricalSummary: PropTypes.object.isRequired,

  firstParameter: PropTypes.string.isRequired,
  secondParameter: PropTypes.string.isRequired,

  isFrequencyTable: PropTypes.bool.isRequired,
  isTypeOfGraphsFrequency: PropTypes.bool,
  getLevelsFrequency: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  filteredDataset: getFilteredDataset()(state),
  categoricalSummary: getCategoricalSummary(state),
  getLevelsFrequency: getLevelsRowFrequencyDatasetByName(state)
});

export default connect(mapStateToProps)(DoubleCategoricalContainer);
